import React, { useEffect, useState } from "react";
import Preloader from "../elements/Preloader";
import HelmetReact from "../elements/HelmetReact";
import HeaderTwo from "../components/HeaderTwo";
import Breadcrumb from "../components/Breadcrumb";
import FooterTwo from "../components/FooterTwo";
import Newsletter from "../components/Newsletter";
import ServiceInnerDetails from "../components/ServiceInnerDetails";

const ServiceRecrutamento = () => {
  let [active, setActive] = useState(true);
  useEffect(() => { setTimeout(function () { setActive(false); }, 500); }, []);
  return (
    <>
      <HelmetReact title={"Recrutamento e Seleção Estratégica"} />
      <HeaderTwo />
      <Breadcrumb title="Recrutamento e Seleção Estratégica" />
      <ServiceInnerDetails serviceId="recrutamento" />
      <FooterTwo />
    </>
  );
};
export default ServiceRecrutamento;